export default class CustomSelection {
  constructor(options) {
    this.active = !!+options.active;
    this.id = options.id;
    this.name = options.name;
    this.propagateSelection = false;
  }

  toggleActiveState() {
    this.active = !this.active;
  }

  updateActiveState(state) {
    this.active = state;
  }

  updatePropagateSelection(state) {
    this.propagateSelection = state;
  }
}
